import * as React  from 'react';
import {getCsrfToken} from './../../../commons/authenticityToken'

const CancelConfirm = (props) => {

  return(
    <>
      <form className="new_m_ticket justify-content-center" action="cancel_complete" acceptCharset="UTF-8" method="post">
        <input name="authenticity_token" type="hidden" value={getCsrfToken()} />
        <input type="hidden" name="_method" value="DELETE"/>
        <input type="hidden" name="d_purchase_ids" value={props.d_purchase_ids}/>
        <input type="hidden" name="total_fee" value={((props.total_price * 1.1)+(props.refund_fee * 1.1))}/>
        
        <h3>キャンセル内容</h3>
        <br/>
        <p>以下の内容でキャンセルの申請を確定します。</p>
        <br/>
        <div className="table-responsive">
          <table id="notice_table" className="table table-bordered">
            <thead>
              <tr className="success">
                <th scope="col" className="text-center col-lg-6">チケット名</th>
                <th scope="col" className="text-center col-lg-2">キャンセル数</th>
                <th scope="col" className="text-center col-lg-2">価格</th>
                <th scope="col" className="text-center col-lg-2">返金額</th>
              </tr>
            </thead>
            <tbody>
              {props.tickets.map((ticket, i) =>
                <>
                  <input type="hidden" name={"tickets[" + i + "][name]"} value={ticket.name}/>
                  <input type="hidden" name={"tickets[" + i + "][unit_price]"} value={ticket.unit_price}/>
                  <input type="hidden" name={"tickets[" + i + "][count]"} value={ticket.count}/>
                  <input type="hidden" name={"tickets[" + i + "][total_price]"} value={ticket.total_price}/>
                  <tr key={i}>
                    <td>{ticket.name}</td>
                    <td className="text-right">{Number(ticket.count).toLocaleString()}</td>
                    <td className="text-right">{Number(ticket.unit_price).toLocaleString()}</td>
                    <td className="text-right">{(ticket.total_price).toLocaleString()}</td>
                  </tr>
                </>
              )}
              <tr>
                <td className="hidden-table-content"></td>
                <td colSpan={2} className="text-center">小計</td>
                <td className="text-right ">{props.total_price.toLocaleString()}</td>
              </tr>
              <tr>
                <td className="hidden-table-content"></td>
                <td colSpan={2} className="text-center">消費税(10%)</td>
                <td className="text-right ">{(props.total_price * 0.1).toLocaleString()}</td>
              </tr>
              <tr>
                <td className="hidden-table-content"></td>
                <td colSpan={2} className="text-center">キャンセル手数料</td>
                <td className="text-right ">{(props.refund_fee * 1.1).toLocaleString()}</td>
              </tr>
              <tr>
                <td className="hidden-table-content"></td>
                <td colSpan={2} className="text-center">合計</td>
                <td className="text-right ">{((props.total_price * 1.1)+(props.refund_fee * 1.1)).toLocaleString()}</td>
              </tr>
            </tbody>
          </table>
          </div>
          <div className="text-center" style={{fontSize: '18px', marginTop: '-6px'}}>キャンセルの手数料として<b className="red">1,100円（税込）</b>がかかります。（後日請求書を送付させて頂きます。）</div>
          <a className="btn btn-primary pull-left ml5 form-btn"
              href={`/tickets/data/purchase${props.company_id ? ('?company_id=' + props.company_id) : '' }`}>戻る</a>
          <input type="submit"
                value="確定"
                className="btn btn-primary pull-right form-btn"
                data-disable-with="確定" />

      </form>
    </>
  )
}

export default CancelConfirm
